import * as API from '@/api'
import * as exitAuthProcessor from '@/helpers/exitAuthorizationProcessor'
import { user } from '@/services'

const ERROR = 'ERROR'
const LOADING_CLASSROOM = 'LOADING_CLASSROOM'
const LOADING_REQUESTS = 'LOADING_REQUESTS'
const TOGGLE_STUDENT_SELECTION = 'TOGGLE_STUDENT_SELECTION'
const ON_STUDENTS = 'ON_STUDENTS'
const CLASSROOMS = 'CLASSROOMS'
const MESSAGE = 'MESSAGE'
const DEFAULT_ERROR_MESSAGE = 'DEFAULT_ERROR_MESSAGE'
const WIPE_MESSAGE = 'WIPE_MESSAGE'

const initialState = {
  data: [],
  error: null,
  message: '',
  loadingClassroom: false,
  loadingRequests: false,
  classrooms: [],
  noStudentsChecked: true
}

const state = { ...initialState }

const mutations = {

  [CLASSROOMS]: function (state, classrooms) {
    state.classrooms = classrooms
  },

  [DEFAULT_ERROR_MESSAGE]: function (state) {
    state.message = 'Não foi possível enviar a solicitação, tente novamente'
  },

  [ERROR]: function (state, error) {
    state.error = error
  },

  [LOADING_CLASSROOM]: function (state, value) {
    state.loadingClassroom = value
  },

  [LOADING_REQUESTS]: function (state, value) {
    state.loadingRequests = value
  },

  [MESSAGE]: function (state, payload) {
    state.message = payload
  },

  [ON_STUDENTS]: function (state, data) {
    state.data = exitAuthProcessor.processData(data, state.data)
    state.noStudentsChecked = exitAuthProcessor.processButtonState(state.data)
  },

  [TOGGLE_STUDENT_SELECTION]: function (state, { responsibleId, studentId, value }) {
    const responsible = state.data.find(item => item.id === responsibleId)
    const student = responsible.studentsCollection.find(item => item.id === studentId)
    student.checked = value

    state.noStudentsChecked = exitAuthProcessor.processButtonState(state.data)
  },

  [WIPE_MESSAGE]: function (state, payload) {
    state.message = ''
  }
}

const actions = {

  async fetchClassrooms ({ commit }, classroom) {
    commit(LOADING_CLASSROOM, true)
    commit(ERROR, null)
    try {
      const building = user.getSelectedBuilding().value
      API.exitAuthorization.classroom.getClassrooms(building)
        .then(response => {
          commit(CLASSROOMS, response.data.classrooms)
        })
    } catch (error) {
      commit(ERROR, error)
      commit(MESSAGE, 'Não foi possível obter as salas, tente novamente mais tarde')
    }
    commit(LOADING_CLASSROOM, false)
  },

  onStudentsReceived ({ commit }, payload) {
    commit(ON_STUDENTS, payload)
  },

  sendStudents ({ commit }, payload) {
    API.exitAuthorization.authorizationInfos.authorize(payload)
      .then(response => {
        commit(MESSAGE, 'Autorização realizada com sucesso!')
      })
      .catch(() => {
        commit(MESSAGE, 'Erro ao enviar solicitação!')
      })
  },

  setAbsentStudent ({ commit }, payload) {
    API.exitAuthorization.authorizationInfos.absentStudent(payload)
      .then(response => {
        commit(MESSAGE, 'Aluno ausentado com sucesso!')
      })
      .catch(error => {
        commit(DEFAULT_ERROR_MESSAGE)
        commit(ERROR, error)
      })
  },

  setPresentStudent ({ commit }, payload) {
    API.exitAuthorization.authorizationInfos.absentStudent(payload)
      .then(response => {
        commit(MESSAGE, 'Aluno presente incluído!')
      })
      .catch(error => {
        commit(DEFAULT_ERROR_MESSAGE)
        commit(ERROR, error)
      })
  },

  toggleStudentSelection ({ commit }, payload) {
    commit(TOGGLE_STUDENT_SELECTION, payload)
  },

  wipeMessage ({ commit }, payload) {
    commit(WIPE_MESSAGE)
  }
}

const getters = {
  getSelectedStudents (state) {
    let selectedStudents = []

    state.data.map(responsible => {
      responsible.studentsCollection.map(student => {
        if (student.checked && !student.absent) {
          selectedStudents.push(student)
        }
      })
    })

    return selectedStudents
  },

  getRequestData (state) {
    let studentIds = []

    state.data.map(responsible => {
      responsible.studentsCollection.map(student => {
        if (student.checked) {
          studentIds.push(student.id)
        }
      })
    })

    const { id } = user.getUserData()

    return {
      id,
      studentIds
    }
  },

  getClassrooms (state) {
    let classrooms = state.classrooms.map((classroom, index) => {
      return { text: classroom, value: index }
    })

    return classrooms
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
